import React, {Fragment, ReactElement, ReactNode} from 'react';
import Head from "next/head";
import {getAssetUrl} from "../../utils/getAssetUrl";

const styles = require('./index.module.less');

type TLayoutProps = {
  children: ReactNode
}

const Layout: React.FC<TLayoutProps> = ({children}): ReactElement => {
  return (
    <Fragment>
      <Head>
        <title>西山居万宝楼</title>
        <meta httpEquiv="content-type" content="text/html;charset=utf-8"/>
        <meta name="viewport" content="initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui"/>
        <link rel="shortcut icon" href={getAssetUrl('/favicon.ico')} type="image/x-icon"/>
      </Head>
      {children}
    </Fragment>
  )
}
export default Layout;